<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">凭证列表</span></div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
			<div class="float-right">
				<template v-if="User.role!=='View' && currentAccountSets.voucherReviewed" >
					<Button :loading="loading" @click="audit" >审核</Button>
					<Button :loading="loading" @click="cancelAudit">取消审核</Button>
				</template>
				<Button button @click="trigger">打印</Button>
<!--        <DropdownMenu button @click="printAll()" :datas="param">打印</DropdownMenu>-->
				<template v-if="User.role!=='View'">
					<Button :loading="loading" @click="finishingOffNo">整理断号</Button>
					<Button :loading="loading" @click="batchDelete">批量删除</Button>
          <Button @click="importSetting">导入</Button>
<!--          <Button @click="exportExcel">导出</Button>-->
          <DropdownMenu class="mx-10px" @click="downloadTrigger" :datas="{all:'导出所有',backThen:'导出当年',current:'导出当期',checked:'导出选中'}" :toggleIcon="false">
            <Button>导出凭证 <i class="fa fa-caret-down"></i></Button>
          </DropdownMenu>
				</template>
			</div>
		</div>
		<div class="h-panel-body">
			<table class="header">
				<tr>
					<th style="width: 50px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
					<td style="width: 215px">摘要</td>
					<td>科目</td>
					<td align="right" style="width: 130px">借方金额</td>
					<td align="right" style="width: 130px">贷方金额</td>
				</tr>
			</table>
			<table v-if="!datas.length">
				<tr>
					<td colspan="5" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table class="details" v-for="data in datas" :key="data.id">
				<tr class="details-header">
					<th style="width: 50px"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
					<td colspan="2">日期：{{data.voucherDate}} 凭证字号：{{data.word}}-{{data.code}} 制单人：{{data.createMemberName}}</td>
					<td colspan="2" class="actions" align="right">
						<router-link tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id,operateType:0}}">查看</router-link>
<!--						<a :href="`/api/pfd/voucher?id=${data.id}`" target="_blank">打印</a>-->
<!--            <span  class="text-hover" @click="viewVoucher(data)">插入</span>-->
            <span v-if="User.role!=='View'" @click="trigger(data)">打印</span>
            <router-link v-if="User.role!=='View'" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id,operateType:1}}">插入</router-link>
						<router-link v-if="User.role!=='View'" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id,operateType:0}}">修改</router-link>
						<span v-if="User.role!=='View'" @click="remove(data)">删除</span>
						<i v-if="data.auditMemberId" class="h-icon-completed green-color" v-tooltip content="已审核"></i>
					</td>
				</tr>
				<tr v-for="(d,i) in data.details" :key="d.id" @click="onClick(i)" :class="{ selected: selectedRow === i }">
					<th></th>
					<td style="width: 215px">
						{{d.summary}}
						<template v-if="d.subject&&d.num&&d.price">
							(数量:{{d.num}}<span class="dark4-color">{{d.subject.unit}}</span>，单价:{{d.price}}<span class="dark4-color">元</span>)
						</template>
					</td>
					<td v-if="d.auxiliaryTitle">{{d.subjectName + d.auxiliaryTitle}}</td>
          <td v-if="!d.auxiliaryTitle">{{d.subjectName}}</td>
					<td align="right" style="width: 130px">{{d.debitAmount|numFormat}}</td>
					<td align="right" style="width: 130px">{{d.creditAmount|numFormat}}</td>
				</tr>
				<tr class="font-bold">
					<td></td>
					<td>合计</td>
					<td>{{data.debitAmount|dxMoney}}</td>
					<td align="right">{{data.debitAmount|numFormat}}</td>
					<td align="right">{{data.creditAmount|numFormat}}</td>
				</tr>
			</table>
			<Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
		</div>
    <Modal v-model="importSettingForm">
      <div slot="header">凭证导入</div>
      <div class="padding">
        <p>第一步： 请点击下面的链接下载Excel模板，并按照模板填写信息</p>
        <a class="blue-color text-hover" @click="downTemplate()" >下载模板</a>
        <p>第二步： 导入Excel模板文件</p>
        <span class="blue-color text-hover" @click="$refs.file.click()">选取文件</span>
        <div class="h-30px mt-8px"><span v-if="fileName">已选：{{ fileName }}</span></div>
        <input type="file" style="visibility: hidden;position: absolute" @change="fileChange()" ref="file">
      </div>
      <div class="text-center">
        <Button color="green" @click="importData" :loading="loading">导入</Button>
        <Button @click="importSettingForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
    <Modal v-model="printSettingForm">
      <div slot="header">凭证打印</div>
      <div class="modal-column">
        <div class="modal-column-body">
          <Form :labelWidth="120">
            <FormItem label="打印选项：">
              <Radio v-model="props.type" :datas="['打印全部','打印选中']"/>
            </FormItem>
            <FormItem label="打印纸张：">
              <Radio v-model="props.page" :datas="['A4(两版)','A4(三版)','A5(210*148)','凭证(240*140)']"/>
            </FormItem>
<!--            <FormItem label="打印字体大小：">
              <Radio v-model="props.size" :datas="['8','9','10','11','12']"/>
            </FormItem>-->
          </Form>
        </div>
        <div class="text-center">
          <Button icon="fa fa-close" @click="printSettingForm=false" :loading="loading">取消</Button>
          <Button color="blue" icon="fa fa-print" @click="print()" :loading="loading">打印</Button>
        </div>
      </div>
    </Modal>
	</app-content>
</template>

<script>
	import Qs from "qs";
	import moment from 'moment'
	import {mapState} from 'vuex'
  import setting from "@/api/setting";
  import * as XLSX from "xlsx-js-style";
  import CustomRadio from "@/views/voucher/CustomRadio";
  export default {
		name: "Voucher",
    components: {
      CustomRadio
    },
		data() {
			return {
				datas: [],
				accountDate: null,
				pagination: {
					page: 1,
					total: 0
				},
        importSettingForm: false,
        printSettingForm :false,
        file: null,
				loading: false,
				checkAll: false,
				param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}],
        selectedRow: null,
        excelDatas: [],
        props: {
          type: '打印全部', // 这是默认的打印选项
          page: '凭证(240*140)', // 这是默认的纸张类型
          size: '10' // 这是默认的字体大小
        },
        printId: null,
			};
		},
		watch: {
			checkAll(nval) {
				let data = Array.from(this.datas);
				data.forEach(val => val._checked = nval);
				this.datas = data;
			},
			accountDate() {
				this.pagination.page = 1;
				this.loadList();
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			date() {
				return moment(this.accountDate);
			},
      fileName() {
        if (this.file) {
          return this.file.name;
        }
        return '';
      }
		},
		methods: {
      downloadTrigger(key) {
        let year = null;
        let month = null;
        let checked = [];
        let type = 2;
        if (key === 'all') {
          type = 4;
        }
        if (key === 'backThen') {
          type = 3;
        }
        if (key === 'current') {
          year = this.date.year();
          month = this.date.month() + 1;
        }
        if (key === 'checked') {
          year = this.date.year();
          month = this.date.month() + 1;
          let params = this.datas.filter(value => value._checked);
          let res = params.map(obj => obj.id)
          checked = res;
          type = 1;
        }
        this.$api.voucher.loadVoucher({checked: checked, year: year, month: month, type: type}).then(({data}) => {
          let arr = [];
          arr = data;
          if (arr.length > 0) {
            const tableData = [
              ['凭证类别','凭证号','凭证日期','摘要','科目编码','科目名称','借方金额','贷方金额','客户名称','供应商名称','职员名称','部门名称','项目名称','存货名称','制单人','审核人'],
            ];
            arr.forEach((item,index) => {

              let rowData = []
              let map;
              if (item.params) {
                map = new Map(Object.entries(item.params));
              }else {
                map = new Map();
              }

              rowData =[
                item.word,
                item.code,
                item.voucherDate,
                item.summary,
                item.subjectCode,
                item.subjectName,
                item.debitAmount ? item.debitAmount : '',
                item.creditAmount ? item.creditAmount : '',
                map.get('客户名称') ? map.get('客户名称') : '',
                map.get('供应商名称') ? map.get('供应商名称') : '',
                map.get('职员名称') ? map.get('职员名称') : '',
                map.get('部门名称') ? map.get('部门名称') : '',
                map.get('项目名称') ? map.get('项目名称') : '',
                map.get('存货名称') ? map.get('存货名称') : '',
                item.createMemberName ? item.createMemberName : '',
                item.aduitMemberName ? item.aduitMemberName : '',
              ]
              tableData.push(rowData)
            })
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(tableData);

            Object.keys(ws).forEach((key) => {

              if (key === 'A1' || key === 'B1' || key === 'C1' || key === 'D1' || key === 'E1' || key === 'F1'
                  || key === 'G1' || key === 'H1' || key === 'I1' || key === 'J1' || key === 'K1'
                  || key === 'L1' || key === 'M1' || key === 'N1' || key === 'O1' || key === 'P1'){
                ws[key].s = {
                  font: {name: '宋体', sz: 14, bold: true},
                  alignment: {horizontal: 'center', vertical: 'center', wrapText: true},
                  border: {top: {style: 'thin'}, bottom: {style: 'thin'}, left: {style: 'thin'}, right: {style: 'thin'}}
                }

              }else {
                if (key.startsWith('A') || key.startsWith('B') || key.startsWith('C') || key.startsWith('D') || key.startsWith('E') || key.startsWith('F')
                    || key.startsWith('G') || key.startsWith('H') || key.startsWith('I') || key.startsWith('J') || key.startsWith('K')
                    || key.startsWith('L') || key.startsWith('M') || key.startsWith('N') || key.startsWith('O') || key.startsWith('P')){
                  ws[key].s = {
                    font: {name: '宋体', sz: 11, bold: false},
                    border: {top: {style: 'thin'}, bottom: {style: 'thin'}, left: {style: 'thin'}, right: {style: 'thin'}},
                  }

                }
              }

            })

            ws['!cols'] = [
              {
                wpx: 100
              }, {
                wpx: 100
              }, {
                wpx: 100
              }, {
                wpx: 150
              },{
                wpx: 100
              },{
                wpx: 150
              }, {
                wpx: 100
              }, {
                wpx: 100
              }, {
                wpx: 100
              }, {
                wpx: 100
              },{
                wpx: 100
              },{
                wpx: 100
              }, {
                wpx: 100
              },{
                wpx: 100
              },{
                wpx: 100
              },{
                wpx: 100
              }

            ]
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, '凭证列表.xlsx');
          }else {
            this.$message.error("该账期不存在凭证信息")
          }
        })

      },
      onClick(i) {
        console.log("点击事件执行————————————————————————————")
        if (this.selectedRow === i) {
          this.selectedRow = -1;
        }else {
          this.selectedRow = i;
        }

      },
      importData() {
        if (this.$refs.file.files.length) {
          let formData = new FormData();
          formData.append('file', this.$refs.file.files[0]);
          this.loading = true;
          setting.subject.import(formData).then(({data}) => {
            this.$message.success("导入成功")
            this.$refs.file.value = "";
            this.$emit('success', data);
          }).finally(() => {
            this.loading = false;
          }).catch(() => {
            this.$refs.file.value = "";
            this.file = null;
          });
        }
      },
      downTemplate() {
        var a = document.createElement("a");
        a.href = "/static/voucher.xlsx";
        a.download = "凭证模板.xlsx";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
      },
      importSetting() {
        this.importSettingForm = true;
      },
			currentChange() {
				this.loadList();
			},
			trigger(data) {
        this.printId = null;
        this.printSettingForm = true;
        if (data.id) {
          this.printId = data.id
        }
			},
      print() {
        let pageType;
        if (this.props.page === 'A4(两版)') {
          pageType = 1;
        }else if (this.props.page === 'A4(三版)') {
          pageType = 2;
        } else if (this.props.page === 'A5(210*148)') {
          pageType = 3;
        }else {
          pageType = 4;
        }
        if (this.printId != null) {
          this.printCheck(pageType);
        }else {
          if (this.props.type === '打印全部') {
            this.printAll(pageType);
          }
          if (this.props.type === '打印选中') {
            this.printCheck(pageType);
          }
        }


      },
      printAll(pageType) {

				let param = Qs.stringify({year: this.date.year(), month: this.date.month() + 1, pageType: pageType, size: this.props.size}, {indices: false});
				window.open(`/api/pfd/voucher?${param}`);
        this.printSettingForm = false;
			},
			printCheck(pageType) {
        if (this.printId != null) {
          let param = Qs.stringify({id: [this.printId], pageType: pageType, size: this.props.size}, {indices: false});
          window.open(`/api/pfd/voucher?${param}`);
        }else {
          let checked = this.datas.filter(value => value._checked);
          if (checked.length) {
            let param = Qs.stringify({id: checked.map(value => value.id), pageType: pageType, size: this.props.size}, {indices: false});
            window.open(`/api/pfd/voucher?${param}`);
          } else {
            this.$Message("未选择记录");
          }
        }
        this.printSettingForm = false;
			},

			loadList() {
				this.$api.voucher.list({voucher_year: this.date.year(), voucher_month: this.date.month() + 1, page: this.pagination.page}).then(({data}) => {
					this.datas = data.records;
					this.pagination = {
						page: data.current,
						size: data.size,
						total: data.total
					}
				})
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.voucher.delete(data.id).then(() => {
						this.loadList();
					})
				});
			},
			finishingOffNo() {
				this.loading = true;
				this.$api.voucher.finishingOffNo({year: this.date.year(), month: this.date.month() + 1}).then(() => {
					this.loadList();
				}).finally(() => {
					this.loading = false
				});
			},
			batchDelete() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("确认删除?").then(() => {
						this.loading = true;
						this.$api.voucher.batchDelete({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
						}).finally(() => {
							this.loading = false
						});
					});
				}
			},
			audit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.audit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
							this.$Message("审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			cancelAudit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要取消审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.cancelAudit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
							this.loadList();
							this.$Message("取消审核成功！");

						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			doUpload() {
				this.$refs.file.click();
			},
			fileChange(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					this.loading = true;
					this.$api.voucher.import(formData).then(({data}) => {
						if (data) {
							this.accountDate = data;
						}
						this.$store.dispatch('init');
						this.$Message("亲,导入成功~");
					}).finally(() => {
						this.loading = false;
					});

					this.$refs.file.value = "";
				}
			}
		}
	};
</script>
<style lang='less' scoped>
.details tr {
  background: #ffffff;
}

.details tr.selected {
  background: rgba(31, 165, 227, 0.2);
}
	.h-panel-body {
		table {
			width: 100%;
			border-collapse: collapse;

			td {
				padding: 7px;
			}

			&.header {
				background-color: @primary-color;
				color: white;
			}
		}

		.details {
			font-size: 12px;
			margin: 15px 0;
			border: 1px solid @gray2-color;

			.actions {
				text-align: right;
				padding-right: 20px;

				span, a {
					display: none;
				}
			}

			input {
				display: none;

				&.display {
					display: inline-block;
				}
			}

			&-header {
				background-color: @gray3-color;
				color: @dark3-color;
			}

			td, th {
				border-bottom: 1px solid @gray2-color;
			}

			tr:hover:not(.details-header) {
        background-color: #F0F6FF;
				cursor: pointer;
			}

			&:hover {
				box-shadow: 0 0 10px 0 #dadada;
				border-color: #dadada;

				.actions {
					span, a {
						display: inline-block;
					}
				}

				input {
					display: inline-block;
				}
			}
		}
	}
</style>
